import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-form-field',
  templateUrl: './error-form-field.component.html',
  styleUrls: ['./error-form-field.component.scss']
})
export class ErrorFormFieldComponent {
  @Input() errorMsg: string | undefined;
}
